/**
	0: 	1110000000000000000000000
	1: 	0000011100000000000000000
	2: 	0000000000111000000000000
	3: 	0000000000000001110000000
	4: 	0000000000000000000011100
	5: 	1010001000000000000000000
	6: 	0000010100010000000000000
	7: 	0000000000101000100000000
	8: 	0000000000000001010001000
	9: 	0100010100000000000000000
	10:	0000001000101000000000000
	11:	0000000000010001010000000
	12:	0000000000000000100010100
	13:	1000001000001000000000000
	14:	0000000000001000100010000

	0: 11100	00000	00000	00000	00000	10101	00000	00000	00000	01000	00000	00000	00000	10000	00000
	1: 00000	11100	00000	00000	00000	01010	10100	00000	00000	10100	01000	00000	00000	01000	00000
	2: 00000	00000	11100	00000	00000	00000	01000	10100	00000	00000	10100	01000	00000	00100	00100
	3: 00000	00000	00000	11100	00000	00000	00000	01000	10100	00000	00000	10100	01000	00000	01000
	4: 00000	00000	00000	00000	11100	00000	00000	00000	01000	00000	00000	00000	10100	00000	10000

	   00000	11111	22222	33333	44444	01010	12121	23232	34343	10101	21212	32323	43434	01234	43210

 */

export const payLinesConfig = [
	{
		positions: [0, 0, 0, 0, 0],
		image: 'winlines-pl_000',
		x: 470,
		y: 90
	},
	{
		positions: [1, 1, 1, 1, 1],
		image: 'winlines-pl_000',
		x: 470,
		y: 270
	},
	{
		positions: [2, 2, 2, 2, 2],
		image: 'winlines-pl_000',
		x: 470,
		y: 460
	},
	{
		positions: [3, 3, 3, 3, 3],
		image: 'winlines-pl_000',
		x: 470,
		y: 650
	},
	{
		positions: [4, 4, 4, 4, 4],
		image: 'winlines-pl_000',
		x: 470,
		y: 830
	},
	{
		positions: [0, 1, 0, 1, 0],
		image: 'winlines-pl_010',
		x: 470,
		y: 180
	},
	{
		positions: [1, 2, 1, 2, 1],
		image: 'winlines-pl_010',
		x: 470,
		y: 360
	},
	{
		positions: [2, 3, 2, 3, 2],
		image: 'winlines-pl_010',
		x: 470,
		y: 550
	},
	{
		positions: [3, 4, 3, 4, 3],
		image: 'winlines-pl_010',
		x: 470,
		y: 740
	},
	{
		positions: [1, 0, 1, 0, 1],
		image: 'winlines-pl_101',
		x: 470,
		y: 180
	},
	{
		positions: [2, 1, 2, 1, 2],
		image: 'winlines-pl_101',
		x: 470,
		y: 370
	},
	{
		positions: [3, 2, 3, 2, 3],
		image: 'winlines-pl_101',
		x: 470,
		y: 560
	},
	{
		positions: [4, 3, 4, 3, 4],
		image: 'winlines-pl_101',
		x: 470,
		y: 740
	},
	{
		positions: [0, 1, 2, 3, 4],
		image: 'winlines-pl_012',
		x: 470,
		y: 460
	},
	{
		positions: [4, 3, 2, 1, 0],
		image: 'winlines-pl_432',
		x: 470,
		y: 460
	}
];
